import { ref } from 'vue'
import { useLocalStorage } from '@/composables/useLocalStorage.js'

export function useOrder() {
  const order = useLocalStorage('__order', []); //ref([])

  function addToOrder(item) {
    const index = order.value.findIndex(i => i.name === item.name)
    if (index !== -1) {
      // Ya existe, incrementa qty
      order.value[index].qty++
    } else {
      // Nuevo producto
      order.value.push({
        name: item.name,
        price: item.price,
        qty: 1
      })
    }
  }

  function removeFromOrder(name) {
    const index = order.value.findIndex(i => i.name === name)
    if (index !== -1) {
      if (order.value[index].qty > 1) {
        order.value[index].qty--
      } else {
        // qty es 1, si lo quitas queda 0, entonces lo sacamos del arreglo
        order.value.splice(index, 1)
      }
    }
  }

  function clearOrder() {
    order.value = []
  }

  return {
    order,
    addToOrder,
    removeFromOrder,
    clearOrder
  }
}
